/* global axios */
import ApiClient from './ApiClient';

class PhoneQueuesAPI extends ApiClient {
  constructor() {
    super('phone_queues', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  pickupCall(callerId) {
    return axios.post(`${this.url}/pickup_call`, {
      caller_id: callerId,
    });
  }
}

export default new PhoneQueuesAPI();
